import BaseService from '@/network/base-service'

class ReceitasService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente`)
  }
  getReceitas () {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/receitas`,
      {
        method: 'GET'
      }
    )
  }
  getArquivo (codigo, prontuario) {
    return this.get(`paciente/receitas/${codigo}?prontuario=${prontuario}`, { responseType: 'blob' })
  }
  getUltimasReceitas () {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/receitas/ultimas`,
      {
        method: 'GET'
      }
    )
  }
  postSolicitarReceitas (solicitacao) {
    return fetch(
      `${process.env.VUE_APP_API_BASE_URL}/paciente/Paciente/receitas/solicitar`,
      {
        method: 'POST',
        body: JSON.stringify(solicitacao),
        headers: {
          credentials: 'same-origin',
          withCredentials: true,
          'Content-Type': 'application/json'
        }
      }
    )
  }
}

export default new ReceitasService()
